export default __webpack_public_path__ + "static/media/Regal Stay Residences.5b103150.jpg";